var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.5.5C9.454.5.5 9.454.5 20.5s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20m2.085 20.879v10.88h-4.502V21.38h-2.25v-3.75h2.25v-2.251c0-3.059 1.27-4.878 4.878-4.878h3.004v3.75h-1.878c-1.404 0-1.497.524-1.497 1.502l-.005 1.877h3.401l-.398 3.75z",
  clipRule: "evenodd"
})));
export default SvgFacebook;